/**
 * Whether the `agent_visible` visibility option is meaningful for a
 * given note anchor.
 *
 * Today only scorecard-service's read path enforces the `agent_visible`
 * gate (desktop scorecard load filters to agent_visible=TRUE notes only).
 * For other anchors — call, task, message — the flag is stored but no
 * read path differentially treats it, so the option in the UI promises
 * something we don't actually deliver. Hide it on those anchors and
 * keep the choice to public/private.
 *
 * Criteria notes (`scorecard_criteria_score`) inherit scorecard semantics
 * since they're loaded through the same scorecard-service paths.
 */
const AGENT_VISIBLE_ANCHORS = new Set(['scorecard', 'scorecard_criteria_score'])

export const allowAgentVisibleFor = (noteType) =>
  Boolean(noteType) && AGENT_VISIBLE_ANCHORS.has(noteType)
